// Libraries
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

// Shared
import { equalityFn } from 'shared/utils/useOrm'

const selector = createSelector(
  [(state) => state.settings, (state) => state.orm.operating_rules],
  (settings, operatingRules) => {
    const types = [settings.get('store.period_type')]

    if (settings.get('store.use_business_hours')) {
      types.push('hours')
    }

    if (settings.get('store.use_away_mode')) {
      types.push('away')
    }

    return operatingRules.getAll({ data_type: types })
  }
)

export const useOpeningHours = () => useSelector(selector, equalityFn)
